import './lab-view.scss';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';

import { PATH } from '../../constants';

import { FIELD_LABELS, LAB_FIELDS } from './lab-constants';

export const LabView = ({ appReducer, match, labReducer, deleteLab }) => {
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const handleDelete = () => {
        setShowDeleteModal(false);
        deleteLab(match.params.id);
    };

    return (
        <div className="lab-view">
            <div className="controls">
                <h2>{R.pathOr('Loading...', ['currentLab', 'id'], labReducer)}</h2>
                {appReducer.appAccess.write ? (
                    <div>
                        {labReducer.currentLab.type === 'VPN' && (
                            <Link to={PATH.labAction(match.params.id, PATH.lab_actions.CERTS)}>Upload Certs...</Link>
                        )}
                        <Link to={PATH.labAction(match.params.id, PATH.lab_actions.EDIT)}>Edit...</Link>
                        <Button variant="danger" onClick={() => setShowDeleteModal(true)}>
                            Delete
                        </Button>
                    </div>
                ) : null}
            </div>
            <Table striped>
                <tbody>
                    {R.map(
                        (key) => (
                            <tr key={key}>
                                <th>{FIELD_LABELS[key]}</th>
                                <td>{R.propOr('---', key, labReducer.currentLab)}</td>
                            </tr>
                        ),
                        R.reject(R.equals('blueprint_file'), LAB_FIELDS),
                    )}
                </tbody>
            </Table>
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete lab{' '}
                    <strong>{R.pathOr('', ['currentLab', 'id'], labReducer)}</strong>? This action cannot be undone.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleDelete}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

LabView.propTypes = {
    appReducer: PropTypes.object,
    labReducer: PropTypes.object,
    match: PropTypes.object,
    deleteLab: PropTypes.func,
};

export default LabView;
